import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink, Globe, User, Camera, Menu } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import NotificationBell from '../common/NotificationBell';
import ProfileModal from '../auth/ProfileModal';

export default function AdminHeader({ title, subtitle, pendingCount = 0, onToggleSidebar = () => {} }) {
  const { user } = useAuth();
  const [profileModalOpen, setProfileModalOpen] = useState(false);

  return (
    <>
      <header className="sticky top-0 z-30 h-16 bg-white/95 backdrop-blur-md border-b border-slate-200 px-3 sm:px-6 flex items-center justify-between shadow-xs shrink-0">
        <div className="flex items-center min-w-0 mr-2">
          {/* Mobile hamburger menu toggle */}
          <button
            type="button"
            onClick={onToggleSidebar}
            className="lg:hidden p-1.5 sm:p-2 -ml-1 mr-2 rounded-lg text-slate-600 hover:text-slate-900 hover:bg-slate-100 transition-colors cursor-pointer shrink-0"
            aria-label="Menyuni ochish"
          >
            <Menu className="w-5 h-5" />
          </button>
          
          <div className="min-w-0">
            <h1 className="font-serif text-base sm:text-lg font-bold text-slate-900 leading-tight truncate">
              {title}
            </h1>
            {subtitle && (
              <p className="text-[11px] sm:text-xs text-slate-500 truncate hidden xs:block">
                {subtitle}
              </p>
            )}
          </div>
        </div>

        <div className="flex items-center space-x-2 sm:space-x-4 shrink-0">
          {/* View Public Website */}
          <Link
            to="/"
            target="_blank"
            className="inline-flex items-center text-xs font-medium text-slate-600 hover:text-slate-900 bg-slate-100 hover:bg-slate-200 p-2 sm:px-3 sm:py-1.5 rounded transition-colors"
            title="Saytni ko‘rish"
          >
            <ExternalLink className="w-3.5 h-3.5 sm:mr-1.5 text-slate-500" />
            <span className="hidden sm:inline">Saytni ko‘rish</span>
          </Link>

          {/* Interactive Notifications Bell */}
          <NotificationBell theme="light" />

          {/* User profile capsule (Clickable to open profile & photo upload) */}
          <button
            type="button"
            onClick={() => setProfileModalOpen(true)}
            className="flex items-center space-x-2 pl-2 sm:pl-3 border-l border-slate-200 hover:bg-slate-50 p-1 sm:p-1.5 rounded-lg transition-colors cursor-pointer text-left shrink-0"
            title="Profil ma’lumotlarini tahrirlash va rasm yuklash"
          >
            {user?.avatar ? (
              <img
                src={user.avatar}
                alt={user.fullName}
                className="w-8 h-8 rounded-full object-cover border border-[#c5a880] shrink-0"
              />
            ) : (
              <div className="w-8 h-8 rounded-full bg-[#091322] text-[#c5a880] flex items-center justify-center font-bold text-xs shrink-0">
                {user?.fullName?.charAt(0) || 'A'}
              </div>
            )}
            <div className="hidden md:block text-left max-w-[120px] lg:max-w-[160px]">
              <span className="text-xs font-semibold text-slate-800 block leading-tight truncate">
                {user?.fullName}
              </span>
              <span className="text-[10px] text-slate-500 font-mono block truncate">
                {user?.role === 'SUPER_ADMIN' ? 'BOSH ADMIN' : user?.role === 'LAWYER' ? 'ADVOKAT' : (user?.username ? `@${user.username}` : 'ADMINISTRATOR')}
              </span>
            </div>
          </button>
        </div>
      </header>

      <ProfileModal
        isOpen={profileModalOpen}
        onClose={() => setProfileModalOpen(false)}
      />
    </>
  );
}
